module.exports = __webpack_public_path__ + "static/media/side-quest.c38a5ab7.svg";